export default async function isOpened() {
    let open = false;
    const localTime = new Date().toLocaleString("en-US", { timeZone: "America/Asuncion" });
    const date = new Date(localTime);

    const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const hour = date.getHours(); // 0 to 23

    if (day === 0) {
        open = false;
    };

    if (hour >= 13 && hour < 23) {
        return true;
    }

    return open;
}

/**@copyright Eze © 2025 */